var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.906,
    height: 55.087,
    viewBox: "0 0 45.906 55.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_118252",
    "data-name": "Trazado 118252",
    d: "M1508.512,680.366l-8-8a15.972,15.972,0,0,0-11.362-4.705h-10.363a11.489,11.489,0,0,0-11.476,11.477V711.27a11.489,11.489,0,0,0,11.476,11.476h22.953a11.49,11.49,0,0,0,11.477-11.476V691.725a15.96,15.96,0,0,0-4.708-11.362Zm-3.245,3.248a11.437,11.437,0,0,1,1.848,2.41h-9.964a2.3,2.3,0,0,1-2.3-2.3v-9.966a11.514,11.514,0,0,1,2.413,1.848l8,8Zm3.363,27.658a6.894,6.894,0,0,1-6.886,6.886h-22.953a6.894,6.894,0,0,1-6.886-6.886V679.136a6.894,6.894,0,0,1,6.886-6.886h10.363c.374,0,.746.018,1.113.052v11.424a6.894,6.894,0,0,0,6.886,6.886h11.424c.034.367.053.739.053,1.113v19.547Zm-9.854-6.645a2.294,2.294,0,0,1,0,3.246l-3.7,3.7a6.8,6.8,0,0,1-9.613,0l-3.7-3.7a2.3,2.3,0,0,1,3.246-3.246l2.968,2.968V697.5a2.3,2.3,0,0,1,4.591,0v10.095l2.968-2.968a2.293,2.293,0,0,1,3.245,0Z",
    transform: "translate(-1467.315 -667.659)",
    fill: "#003763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoDownload);
export default __webpack_public_path__ + "static/media/Icono-Download.534930890f040a952b898fb85c9101f1.svg";
export { ForwardRef as ReactComponent };